module.exports = __webpack_public_path__ + "img/icon.8e8b0609.png";